import businessAddressesService from "@/services/businessAddresses";
import serviceHandler from "@/helpers/handlers/service";

import moment from "moment";
import isEmpty from "lodash/isEmpty";
import { GTM_EVENT_NAME } from "@/enums/gtm-events";

export default {
  name: "GoogleMyBusinessChartData",
  props: {
    businessAddress: {
      type: Object,
      default: () => {}
    },
    selectedChartItem: {
      type: Object,
      default: () => {}
    },
    month: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      chartLoading: false,
      currentMonth: {},
      chartData: {
        labels: [],
        data: []
      },
      items: [
        {
          label: this.$t(
            "message.visibility.GMBSummary.history.select.centerRate"
          ),
          value: "score",
          scale: { min: 0, suggestedMax: 100, stepSize: false, value: "score" }
        },
        {
          label: this.$t(
            "message.visibility.GMBSummary.history.select.googleMapsRate"
          ),
          value: "reviews_rating",
          scale: {
            min: 1,
            suggestedMax: 5,
            stepSize: 1,
            value: "reviews_rating"
          }
        },
        {
          label: this.$t(
            "message.visibility.GMBSummary.history.select.googleMapsRatingQty"
          ),
          value: "reviewers",
          scale: {
            min: 0,
            suggestedMax: 20,
            stepSize: false,
            value: "reviewers"
          }
        },
        {
          label: this.$t(
            "message.visibility.GMBSummary.history.select.profileCompletness"
          ),
          value: "profile_completeness",
          scale: {
            min: 0,
            suggestedMax: 100,
            stepSize: false,
            value: "profile_completeness"
          }
        }
      ]
    };
  },

  async created() {
    await this.getCurrentMonth();
    await this.fetchGoogleMyBusinessAuditsHistory();
  },

  watch: {
    "selectedChartItem.value"(newValue) {
      this.selected = newValue;

      this.$gtm.trackCustomEvent({
        event: GTM_EVENT_NAME.LOCATIONS_QUALITY_ITEM_ACTION,
        location_id: this.businessAddress.id,
        action: `history_param_${newValue}`
      });

      this.fetchGoogleMyBusinessAuditsHistory(newValue);
    },

    month(newValue) {
      this.getCurrentMonth(newValue);
      this.fetchGoogleMyBusinessAuditsHistory(this.selectedChartItem.value);
    }
  },

  methods: {
    getCurrentMonth(month) {
      month = month || moment();
      this.currentMonth = month;
    },

    async fetchGoogleMyBusinessAuditsHistory(type) {
      this.chartLoading = true;
      type = type || this.items[0].value;

      const payload = {
        from: moment(this.currentMonth)
          .startOf("month")
          .format("YYYY-MM-DD"),
        to: moment(this.currentMonth)
          .endOf("month")
          .startOf("day")
          .format("YYYY-MM-DD")
      };

      const data = await serviceHandler(
        businessAddressesService.getGoogleMyBusinessAuditsHistory(
          this.businessAddress.id,
          payload,
          type
        )
      );

      if (data.length > 0) {
        let obj = {
          data: [],
          labels: []
        };

        data.map(item => {
          obj.data.push({ t: item.created_at, y: item[type] });
          obj.labels.push(item.created_at);
        });

        this.chartData = obj;
        this.chartLoading = false;
        return;
      }

      this.chartData = {
        data: [],
        labels: []
      };

      this.chartLoading = false;
    }
  },

  render() {
    return this.$scopedSlots.default({
      currentMonth: this.currentMonth,
      chartData: this.chartData,
      items: this.items,
      select: !isEmpty(this.selectedChartItem)
        ? this.selectedChartItem
        : this.items[0],
      chartLoading: this.chartLoading
    });
  }
};
